import "./index.css";
import React, { useEffect, useRef, useState } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarController, BarElement, Title, Tooltip, Legend } from "chart.js";
import { useLists } from "./contexts/Lists";
import { getSearchableCities, getSearchableAreas, getNamesFromCitiesIds, getNamesFromAreasIds } from "./utils/lists";
import Map1 from "./components/Map";
import History from "./components/History";
import Charts from "./components/Charts";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "leaflet/dist/leaflet.css";
import { useIsVisible } from "./hooks/useIsVisible";
import Header from "./components/Header";
import PopupContent from "./components/PopupContent";
import { isMobileDevice } from "./utils/utils";

function App() {
  const { cities, polygons } = useLists();
  const [data, setData] = useState([]);

  const [filterdData, setFilteredData] = useState([]);

  const searchParams = new URLSearchParams(window.location.search);

  const [mode, setMode] = useState(searchParams.get("mode") ? Number(searchParams.get("mode")) : 1);

  const [startDate, setStartDate] = useState(searchParams.get("start") || "2023-10-07");
  const [endDate, setEndtDate] = useState(searchParams.get("end") || new Date().toISOString().split("T")[0]);

  const [citiesIdsFilter, setCitiesIdsFilter] = useState(
    searchParams.get("cities")
      ? searchParams
          .get("cities")
          .split(",")
          .map((id) => Number(id))
      : []
  );
  const [areasIdsFilter, setAreasIdsFilter] = useState(
    searchParams.get("areas")
      ? searchParams
          .get("areas")
          .split(",")
          .map((id) => Number(id))
      : []
  );
  const [filterByThreat, setFilterByThreat] = useState(searchParams.get("threat") ? parseInt(searchParams.get("threat"), 10) : -1);
  const [selectPopupOpen, setSelectPopupOpen] = useState(false);

  const mapRef = useRef();
  const chartRef = useRef();
  const chartWatchRef = useRef();

  const historyRef = useRef();
  const searchRef = useRef();

  useEffect(() => {
    const dataCopy = data
      .map((a) => {
        const copy = { ...a };
        if (citiesIdsFilter.length === 0 && areasIdsFilter.length === 0) {
          return a;
        }
        copy.cities = copy.cities.filter((city) => {
          return citiesIdsFilter.includes(city.id) || areasIdsFilter.includes(city.areaId);
        });
        return copy;
      })
      .filter((a) => {
        if (a.cities.length === 0) return false;
        if (filterByThreat === -1) return true;
        if (filterByThreat !== a.threat) return false;
        return true;
      });

    // if (dataCopy.length === 0) {
    //   setFilteredData([]);
    //   return;
    // }

    if (mode === 0) setFilteredData(dataCopy.filter((a) => a.time > (Date.now() - 24 * 60 * 60 * 1000) / 1000));

    if (mode === 1) setFilteredData(dataCopy.filter((a) => a.time > (Date.now() - 7 * 24 * 60 * 60 * 1000) / 1000));

    if (mode === 2) setFilteredData(dataCopy.filter((a) => a.time > (Date.now() - 30 * 24 * 60 * 60 * 1000) / 1000));

    if (mode === 3) {
      const start = new Date(startDate);
      start.setHours(0);

      const end = new Date(endDate);
      end.setHours(23);
      end.setMinutes(59);
      end.setSeconds(59);

      setFilteredData(dataCopy.filter((a) => a.time > start.getTime() / 1000 && a.time < end.getTime() / 1000));
    }

    //setUrl
    const url = new URL(window.location);
    url.search = "";

    const keysForHistory = {};
    if (mode === 0 || mode === 2) keysForHistory.mode = mode;
    if (mode === 3) {
      keysForHistory.mode = mode;
      if (endDate !== new Date().toISOString().split("T")[0]) keysForHistory.end = endDate;
      if (startDate !== "2023-10-07") keysForHistory.start = startDate;
    }
    if (citiesIdsFilter.length) keysForHistory.cities = citiesIdsFilter.join(",");
    if (areasIdsFilter.length) keysForHistory.areas = areasIdsFilter.join(",");

    if (filterByThreat !== -1) keysForHistory.threat = filterByThreat;

    Object.entries(keysForHistory).map(([k, v]) => {
      url.searchParams.set(k, v);
    });
    window.history.replaceState(null, null, url.toString());

    //setUrl
  }, [startDate, endDate, mode, data, citiesIdsFilter, areasIdsFilter, filterByThreat]);

  useEffect(() => {
    if (!cities?.cities) return;
    fetch("/static/historical/all.json")
      .then((c) => c.json())
      .then((d) => {
        d = d.map(([alertId, threat, cities, time]) => ({ alertId, threat, cities, time }));
        d = d.filter((a) => !a.isDrill && !a.threat != 9).sort((a, b) => a.time - b.time);
        let noMatch = new Set();
        setData(
          d.map((z) => {
            z.date = new Date(z.time * 1000);
            z.cities = z.cities.map((c) => {
              const match = cities?.cities?.[c];
              if (!match && cities?.cities) noMatch.add(c);
              if (!match)
                return {
                  value: c,
                  name: c,
                  areaName: c,
                  id: null,
                };

              return {
                value: c,
                name: match.he,
                areaName: cities.areas[match.area].he,
                areaId: match.area,
                id: match.id,
              };
            });
            return z;
          })
        );
        console.log("nomatch", noMatch);
      });
  }, [cities]);

  return (
    <div className="App rtl bg-[#1F1F21]">
      <Header mapRef={mapRef} chartsRef={chartRef} historyRef={historyRef} searchRef={searchRef} chartWatchRef={chartWatchRef} />

      <div className="content m-auto text-center w-full 1 ">
        <div ref={searchRef}>
          <div className="flex w-fit m-auto gap-5 mt-2">
            <div style={{ borderBottom: mode === 0 ? "solid 3px #d20202" : "" }} onClick={() => setMode(0)}>
              <h5 className="text-white text-xl">יממה אחרונה</h5>
            </div>
            <div style={{ borderBottom: mode === 1 ? "solid 3px #d20202" : "" }} onClick={() => setMode(1)}>
              <h5 className="text-white text-xl">שבוע אחרון</h5>
            </div>
            <div style={{ borderBottom: mode === 2 ? "solid 3px #d20202" : "" }} onClick={() => setMode(2)}>
              <h5 className="text-white text-xl ">חודש אחרון</h5>
            </div>
            <div style={{ borderBottom: mode === 3 ? "solid 3px #d20202" : "" }} onClick={() => setMode(3)}>
              <h5 className="text-white text-xl">
                <i className="far fa-calendar"></i>
              </h5>
            </div>
          </div>

          {mode === 3 && (
            <div className="mt-2">
              <p className="inline-block text-white">מ</p>{" "}
              <input
                type="date"
                className="rounded-md p-1 bg-[#111111] text-white white color mx-2"
                value={startDate}
                onChange={({ target }) => setStartDate(target.value)}
              />
              <p className="inline-block text-white">עד</p>{" "}
              <input
                type="date"
                className="rounded-md p-1 bg-[#111111] text-white white color mx-2"
                value={endDate}
                onChange={({ target }) => setEndtDate(target.value)}
              />
            </div>
          )}
        </div>
        <div className="flex gap-4  m-auto w-fit mt-3">
          {
            <div
              onClick={() => setSelectPopupOpen(true)}
              className="border-r-4 text-right bg-white  py-[1px] px-2 rounded-xl cursor-pointer truncate w-[162px] max-w-[162px] max-h[22px]"
            >
              {citiesIdsFilter.length === 0 && areasIdsFilter.length === 0
                ? "כל הארץ"
                : [...getNamesFromAreasIds(areasIdsFilter, cities), ...getNamesFromCitiesIds(citiesIdsFilter, cities)]
                    .map((t) => (!t.area ? "אזור " : "") + t.name)
                    .join(", ")}
            </div>
          }

          <Popup
            onClose={() => setSelectPopupOpen(false)}
            open={selectPopupOpen}
            closeOnEscape={true}
            contentStyle={{ display: "flex", flexDirection: "column", background: "#373737", height: "300px", border: "none", width: "90%", maxWidth: "450px" }}
            className="bg-[#373737]"
            modal={true}
            position="center"
          >
            <PopupContent
              areasIdsFilter={areasIdsFilter}
              citiesIdsFilter={citiesIdsFilter}
              setAreasIdsFilter={setAreasIdsFilter}
              setCitiesIdsFilter={setCitiesIdsFilter}
              cities={cities}
              setSelectPopupOpen={setSelectPopupOpen}
            />
          </Popup>
          <select value={filterByThreat} onChange={({ target }) => setFilterByThreat(Number(target.value))} className="rounded-xl">
            <option value="-1">כל האיומים</option>
            <option value="0">צבע אדום</option>
            <option value="1">אירוע חומרים מסוכנים</option>
            <option value="2">חשש לחדירת מחבלים</option>
            <option value="3">רעידת אדמה</option>
            <option value="4">חשש לצונאמי</option>
            <option value="5">חדירת כלי טיס עוין</option>
            <option value="6">חשש לאירוע רדיולוגי</option>
            <option value="7">ירי בלתי קונבנציונלי</option>
            <option value="8">איומים אחרים</option>
          </select>
        </div>
        <div className="text-red-500 mt-[3px]">
          נמצאו <b>{filterdData.length?.toLocaleString()}</b> התרעות
        </div>
      </div>

      <div className="max-w-[1500px] m-auto pt-5 px-4 ">
        <Charts data={filterdData} reRenderCause={selectPopupOpen} chartRef={chartRef} chartWatchRef={chartWatchRef} />
        <div className="h-[66px] md:h-[50px]"></div>
        <div className="flex flex-wrap  md:flex-row flex-col-reverse gap-1">
          <div className=" md:w-[49%] p-1 overflow-auto w-[100%]">
            <h1 className="text-white font-bold text-lg" ref={!isMobileDevice() ? historyRef : null}>
              היסטוריה
            </h1>
            <div className=" max-h-[90vh] overflow-auto w-full">
              <History data={filterdData} />
            </div>
          </div>
          <div className="block md:hidden mt-[20px] h-6" ref={isMobileDevice() ? historyRef : null}></div>
          <div className="map z-10 h-[90vh] md:w-[49%] p-1  w-[100%]">
            <h1 className="text-white font-bold text-lg" ref={mapRef}>
              מפה
            </h1>
            <div
              className="absolute z-[999] mr-2 mt-2  w-5 h-[20px] w-[200px] md:w-[250px] border-black border-2 rounded-xl shadow-md"
              style={{ background: "linear-gradient(to right, green, yellow, orange, red)" }}
            ></div>
            <Map1 data={filterdData} />
          </div>
        </div>
      </div>
      <div className="bg-red-600 w-full h-[5vh]  align-middle flex md:hidden mt-5">
        <span className="m-auto font-bold text-white text-lg">מערכת צופר</span>
      </div>
    </div>
  );
}

export default App;
